/* eslint-disable @angular-eslint/directive-selector */
import { DestroyRef, Directive, effect, inject, OnInit, Renderer2, TemplateRef, ViewContainerRef } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NavigationsService } from "@evc/platform";
import { NavigationMenuService } from "../services/navigation-menu/navigation-menu.service";
import { filter } from "rxjs";

@Directive({
  selector: "[leftbarTopContent]",
  standalone: true
})
export class LeftbarTopContentDirective implements OnInit {
  private destroyRef = inject(DestroyRef);
  private ctaRootNode: Element | null = null;

  constructor(
    private navigationMenu: NavigationMenuService,
    private viewRef: ViewContainerRef,
    private navigationService: NavigationsService,
    private renderer: Renderer2
  ) {
    effect(() => {
      this.addCollapsedStyleIfLeftBarClose();
    });
  }

  addCollapsedStyleIfLeftBarClose() {
    const isOpen = this.navigationService.isLeftbarOpen();
    if (this.ctaRootNode) {
      if (isOpen) {
        this.renderer.removeClass(this.ctaRootNode, "collapsed");
      } else {
        this.renderer.addClass(this.ctaRootNode, "collapsed");
      }
    }
  }

  ngOnInit(): void {
    this.navigationMenu.cta
      .pipe(
        filter((x) => !!x),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((template: TemplateRef<unknown>) => {
        this.viewRef.clear();
        const ref = this.viewRef.createEmbeddedView(template);
        this.ctaRootNode = ref.rootNodes[0];
        this.addCollapsedStyleIfLeftBarClose();
      });
  }
}
